import * as Sentry from '@sentry/react'

// Error monitoring. Completely DORMANT until you set VITE_SENTRY_DSN in .env —
// no network calls, no overhead, safe to ship without an account.
//
// To turn on: create a free project at sentry.io (platform: React), copy the
// DSN, and add to .env:  VITE_SENTRY_DSN=https://....ingest.sentry.io/...
const dsn = import.meta.env.VITE_SENTRY_DSN

export function initSentry() {
  if (!dsn) return
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE, // "production" / "development"
    // Errors only — light footprint. Raise tracesSampleRate later for perf data.
    tracesSampleRate: 0,
    // Noisy browser quirks that aren't real bugs.
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
    ],
  })
}

// Forward a caught React error (from an ErrorBoundary) to Sentry. No-op if the
// DSN isn't configured.
export function captureError(error, context) {
  if (!dsn) return
  Sentry.captureException(error, context ? { extra: context } : undefined)
}
